export const themes = {
  default: {
    thItemImage: 'relative',
    thItemLabel:
      'flex items-baseline font-bold leading-normal mt-2 overflow-hidden text-base text-gray-darker',
    thItemLabelIcon: 'flex-shrink-0 text-blue rtl:mr-1',
    thItemLabelIconSize: '1em',
  },
};
